<template>
  <div>
    <section>
      <div class="flex-wrap -mx-4 flex justify-center">
        <div class="w-full px-4">
          <h2 class="mb-3 checkup-h2">
            Ich habe eine schwere Krankheit
            <AppButton
              class="ml-2 hint-icon"
              type="primary"
              plain
              circle
              size="small"
              title="Weitere Infos anzeigen"
              @click="showModal = true"
            >
              <FaIcon name="info" />
            </AppButton>
          </h2>
          <SchwereKrankheitenModal v-model:show="showModal" />
          <FieldError
            v-for="error in formErrors.hatSchwereKrankheit"
            :key="error"
          >
            {{ error }}
          </FieldError>
        </div>
      </div>
      <div
        id="OptionHasIllness"
        class="OptionIconGroup"
      >
        <OptionGroup
          has-icons
          :options="[
            {label: 'Ja', labelClasses: `${form.hatSchwereKrankheit === 1 ? 'text-green-700' : 'flex flex-col'}`, value: 1, icon: 'icomoon/check', iconClass: `check ${form.hatSchwereKrankheit === 1 ? 'fill-green-700' : ''}`},
            {label: 'Nein', labelClasses: `${form.hatSchwereKrankheit === 0 ? 'text-red-700' : 'flex flex-col'}`, value: 0, icon: 'icomoon/close', iconClass: `close ${form.hatSchwereKrankheit === 0 ? 'fill-red-700' : ''}`}
          ]"
          :value="form.hatSchwereKrankheit"
          option-width-classes="w-1/3 sm:w-1/4 md:w-1/6"
          @change="set('hatSchwereKrankheit', $event)"
        />
      </div>
      <div v-if="form.hatSchwereKrankheit == 1">
        <div class="flex-wrap -mx-4 flex justify-center mb-7">
          <div class="w-full sm:w-5/6 md:w-1/2 px-4">
            <ElFormItem
              label="Diagnose"
              for="Diagnose"
              :error="formErrors.diagnose?.[0]"
              label-position="top"
            >
              <ElInput
                id="Diagnose"
                v-model="form.diagnose"
                type="textarea"
                :placeholder="`Bitte ${duzen('gebe', 'geben Sie')} hier Ihre Diagnose ein.`"
                :rows="8"
              />
            </ElFormItem>
          </div>
        </div>
      </div>
    </section>
    <section>
      <div class="flex-wrap -mx-4 flex justify-center">
        <div class="w-full px-4">
          <h2 class="mt-7 mb-3 checkup-h2">
            Ich hatte einen schweren Unfall
          </h2>
          <FieldError
            v-for="error in formErrors.hatteUnfall"
            :key="error"
          >
            {{ error }}
          </FieldError>
        </div>
      </div>
      <OptionGroup
        has-icons
        :options="[
          {label: 'Ja', labelClasses: `${form.hatteUnfall === 1 ? 'text-green-700' : 'flex flex-col'}`, value: 1, icon: 'icomoon/check', iconClass: `check ${form.hatteUnfall === 1 ? 'fill-green-700' : ''}`},
          {label: 'Nein', labelClasses: `${form.hatteUnfall === 0 ? 'text-red-700' : 'flex flex-col'}`, value: 0, icon: 'icomoon/close', iconClass: `close ${form.hatteUnfall === 0 ? 'fill-red-700' : ''}`}
        ]"
        :value="form.hatteUnfall"
        option-width-classes="w-1/3 sm:w-1/4 md:w-1/6"
        @change="set('hatteUnfall', $event)"
      />
    </section>
  </div>
</template>

<script setup lang="ts">
import FieldError from '@/application/components/ui/FieldError.vue';
import AppButton from '@/application/components/ui/AppButton.vue';
import FaIcon from '@/application/components/ui/FaIcon.vue';
import { ElFormItem, ElInput } from 'element-plus';
import { ref } from 'vue';

import OptionGroup from '@/checkup/components/OptionGroup.vue';
import SchwereKrankheitenModal from '@/checkup/components/steps/SchwereKrankheitenModal.vue';
import { useStep } from '@/checkup/state';
import { Step } from '@/checkup/utils/steps';
import { useBaseDataStore } from '@/user/store/baseDataStore.ts';

const { form, formErrors, set } = useStep(Step.GESUNDHEIT);
const { duzen } = useBaseDataStore();

const showModal = ref(false);
</script>
